<template>
  <div>
    <bs-page-title
      :titleLabel="fromParentTitle"
      :btnLabel="
        chk_relation_type_editable('/master/list') ? fromParentBtn : ''
      "
      :btnClass="'btn-primary'"
      :btnToLink="'/race_owner_type_cd/add'"
      :routerSw="true"
    ></bs-page-title>
    <bs-msg-alert :alertClass="alertClass">{{
      this.alertMessage
    }}</bs-msg-alert>
    <!-- {{ race_owner_type_cd_obj }} -->

    <div
      class="w100"
      v-if="
        typeof race_owner_type_cd_list === 'object' &&
        Object.keys(race_owner_type_cd_list).length > 0
      "
    >
      <table class="table">
        <thead>
          <tr>
            <th style="width: 10%">種別コード</th>
            <th style="width: 30%">名称</th>
            <th style="width: 10%">GRADE</th>
            <th colspan="2" style="width: 15%">action</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="list in race_owner_type_cd_list" :key="list.id">
            <td>{{ list.race_owner_type_cd }}</td>
            <td>{{ list.label }}</td>
            <td>{{ list.grade_label }}</td>
            <td>
              <bs-button
                :btnClass="'btn-light btn-sm btn-outline-secondary'"
                @to_click_event="handleClick(list.id)"
                >詳細</bs-button
              >
            </td>
            <td>
              <bs-button
                v-if="chk_relation_type_editable('/master/list')"
                :btnClass="'btn-danger btn-sm'"
                @to_click_event="delData(list.id)"
                >削除</bs-button
              >
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-else>
      <p class="alert alert-warning">NO DATA</p>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import BsPageTitle from '../../molecules/BsPageTitle.vue'
import BsMsgAlert from '../../atoms/BsMsgAlert.vue'
// import '../../assets/bootstrap/css/sc.css';
// import Common from '../common/common'
import BsButton from '../../atoms/BsButton.vue'
import config from '../../../const'

export default {
  name: 'RaceOwnerTypeCdListView',
  data: function () {
    return {
      alertMessage: '',
      alertClass: 'alert-info',
      fromParentTitle: '主催者種別コードマスタ一覧',
      fromParentBtn: 'データ登録',
      race_owner_type_cd_obj: [],
      race_owner_type_grade_obj: []
    }
  },
  components: {
    BsPageTitle,
    BsButton,
    BsMsgAlert
  },
  computed: {
    ...mapState({}),
    race_owner_type_cd_list: function () {
      const lists = [...this.race_owner_type_cd_obj]
      return lists.sort((a, b) => {
        if (parseInt(a.sort) < parseInt(b.sort)) {
          return -1
        } else {
          return 1
        }
      })
    },
    race_owner_type_grade_list: function () {
      return this.race_owner_type_grade_obj
    }
  },

  async created() {
    this.race_owner_type_grade_obj = await this.getConfigAPI(
      'race_owner_type_grade'
    )
    await this.loadRaceOwnerTypeCdList()
  },
  mounted: function () {
    // console.log(this.$route.path);
    // console.log('strage', this.$store.state.article, this.lists);
    // this.fromParentTitle = '商品詳細';
    this.alertMessage = '主催者種別コードマスタです。'
  },

  methods: {
    delData(target) {
      if (confirm('削除しますか？')) {
        const data = this.race_owner_type_cd_obj.find(event => {
          return event.id == target
        })
        // console.log('ret ticket data' ,ticket);
        data['stat'] = 9
        return this.$store
          .dispatch('updateBasic', {
            data: data,
            target: 'race_owner_type_cd'
          })
          .then(() => {
            this.alertMessage = '削除しました'
            this.alertClass = 'alert-success'
          })
          .catch(err => {
            // Promise.reject(err)
            console.log(err)
            this.alertMessage = '削除できませんでした'
            this.alertClass = 'alert-danger'
          })
          .finally(() => {
            this.loadRaceOwnerTypeCdList()
          })
      }
    },
    async loadRaceOwnerTypeCdList() {
      const params = {}
      params['stat'] = [1]
      await this.basicPosts_S(
        config.BASE_API_URL + '/race_owner_type_cd/lists',
        params
      )
        .then(async response => {
          console.log('loadRaceOwnerTypeCdList response', response)
          this.race_owner_type_cd_obj =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log(err)
          this.race_owner_type_cd_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    handleClick(target) {
      this.$router.push({ path: '/race_owner_type_cd/' + target + '/' })
    }
  }
}
</script>
